<template>
    <div>
        <div v-if="getClaimedItems && getClaimedItems.length > 0" class="scroller">
            <div class="item-cell" v-for="(item, index) in getClaimedItems" :key="index">
                <div @click="clickForPrize(item)" class="item-center vat vat-claimed"
                    v-if="item.itemStatus == 'claimed'">
                    <ContainerObject :containerObject="getCategoryContainer(item.categoryId, 'claimed')
                        " />
                </div>

                <div @click="clickForRedemption(item)" class="item-center vat vat-allocated"
                    v-if="item.itemStatus == 'allocated'">
                    <ContainerObject :class="{ 'grey-out': item?.shareStatus == 'pending' }" :id="item.id"
                        :containerObject="getPrizeContainer(item.prizeId!, 'allocated')" />
                </div>

                <div @click="showRedeemedPopup(item)" class="item-center vat vat-redeemed"
                    v-if="item.itemStatus == 'redeemed'">
                    <ContainerObject :containerObject="getPrizeContainer(item.prizeId!, 'redeem')" />
                </div>
            </div>
        </div>
        <LoadingComponent v-if="loading" />
    </div>
</template>

<script lang="ts">
import { ItemStatus, VItem } from "@/types/vItem"

import { Action, ActionType, Container } from "@/types/customPage"
import { RedemptionType } from "@/types/prize"
import LoadingComponent from "@/components/utils/LoadingComponent.vue"
import { defineComponent } from "vue"
import { emptyContainerWithMessage } from "@/utils/container"
import { navigationStore } from "@/store/pinia_modules/navigationStore"
import { vItemStore } from "@/store/pinia_modules/vItemStore"
import { authStore } from "@/store/pinia_modules/authStore"
import { prizeStore } from "@/store/pinia_modules/prizeStore"
import { dropPoolStore } from "@/store/pinia_modules/dropPoolStore"
import { categoryStore } from "@/store/pinia_modules/categoryStore"

export default defineComponent({
    data() {
        return {
            loyaltyVats: [] as VItem[],
        }
    },
    async mounted() {
        navigationStore().setloading(true);

        this.configureLoyalty()
        if (this.$route.query.popup) {
            navigationStore().emitAction({
                type: ActionType.OPEN_POPUP,
                value: this.$route.query.popup as string,
            })
        }
        if (this.$route.query.popup) {
            navigationStore().emitAction({
                type: ActionType.OPEN_POPUP,
                value: this.$route.query.popup as string,
            })
        }
        navigationStore().setloading(false);
    },
    computed: {
        loading(): boolean {
            return navigationStore().getLoading
        },
        getClaimedItems(): VItem[] {
            const items: VItem[] = []
            const allItems = vItemStore().getClaimedItems
            for (let i = 0; i < allItems.length; i++) {
                if (
                    this.getCategoryByID(allItems[i].categoryId)
                ) {
                    items.push(allItems[i])
                }
            }
            return items
        },
        action(): Action {
            return navigationStore().getAction
        },
    },
    watch: {
        action(to: Action, from: Action): void {
            console.log(`ScrollerComponent: Watch 'action' triggered. New action:`, JSON.stringify(to), 'Old action:', JSON.stringify(from));
            if (to) {
                if (to.type == "show-scanner") {
                    const campaignId = authStore().getCampaignID
                    this.$router.push(`/${campaignId}/scanner`).catch(() => {
                        //
                    })
                } else if (to.type == "go-to-page") {
                    console.log(`ScrollerComponent: Watch 'action' - processing 'go-to-page' with value: ${to.value}`);
                }
            }
        },
        getClaimedItems() {
            setTimeout(() => {
                this.configureLoyalty()
                this.configureShareReward()
            }, 10)
        },
    },
    methods: {
        async configureLoyalty() {
            //get the loyalty vats
            console.log("running loyalty")
            this.loyaltyVats = this.getClaimedItems.filter(
                (e) => e.type == "loyalty" && e.itemStatus == ItemStatus.CLAIMED
            )

            if (this.loyaltyVats.length > 0) {
                for (let i = 0; i < this.loyaltyVats.length; i++) {
                    const loyaltyVAT = this.loyaltyVats[i]
                    const loyaltyConfig = loyaltyVAT.categoryConfig!
                    const loyaltyState = loyaltyVAT.loyaltyState!
                    if (loyaltyState.complete) {
                        await vItemStore().allocatePrize(loyaltyVAT!.id!)
                        return
                    }

                    const total = loyaltyState.total
                    const collected = loyaltyState.collected
                    let collectedList = this.formatListWithCommas(
                        loyaltyState.collectedList
                    )
                    let unCollectedList = this.formatListWithCommas(
                        loyaltyState.unCollectedList
                    )
                    const category = this.getCategoryByID(loyaltyVAT.categoryId)
                    const vatName = category!.name || ""
                    const loyaltyPreloader = document.getElementById(
                        `${vatName}-preloader`
                    )
                    const loyaltyVatText = document.getElementById(
                        `${vatName}-vat-text`
                    )
                    const loyaltyVatImage = document.getElementById(
                        `${vatName}-vat-image`
                    )
                    const loyaltyPopupText =
                        document.getElementById(`loyalty-popup-text`)
                    if (loyaltyPreloader) {
                        const percentage = (collected / total) * 100
                        console.log("percentage", percentage)
                        loyaltyPreloader.style.width = `${percentage}%`
                    }
                    if (loyaltyVatText) {
                        loyaltyVatText.innerText = loyaltyState.initText
                            .replace(/{total}/g, total.toString())
                            .replace(/{collected}/g, collected.toString())
                    }
                    if (loyaltyPopupText) {
                        loyaltyPopupText.innerText =
                            loyaltyConfig.initLoyaltyFaceCardText
                                .replace(/{total}/g, total.toString())
                                .replace(/{collected}/g, collected.toString())
                                .replace(/{collectedList}/g, collectedList)
                                .replace(/{unCollectedList}/g, unCollectedList)
                    }
                    if (
                        loyaltyVatImage &&
                        loyaltyState.image &&
                        loyaltyState.image != ""
                    ) {
                        loyaltyVatImage.style.backgroundImage = `url(${loyaltyState.image})`
                        loyaltyVatImage.style.backgroundPosition = "center"
                        loyaltyVatImage.style.backgroundSize = "cover"
                    }
                }
            }
        },
        formatListWithCommas(collectedList: string[]) {
            if (collectedList.length === 0) {
                return ""
            } else if (collectedList.length === 1) {
                return collectedList[0]
            } else if (collectedList.length === 2) {
                return collectedList.join(" and ")
            } else {
                var lastItem = collectedList.pop()
                var formattedList =
                    collectedList.join(", ") + ", and " + lastItem
                return formattedList
            }
        },
        configureShareReward() {
            const shareButtons =
                document.querySelectorAll<HTMLElement>(".share-reward")
            const shareText =
                document.querySelectorAll<HTMLElement>(".share-text")
            for (let i = 0; i < shareButtons.length; i++) {
                //get closest parent element with id attribute
                const parent = shareButtons[i].closest("[id]")
                if (parent && parent.id) {
                    //Get the vat associated with the share button
                    const vat = this.getClaimedItems.find(
                        (e) => e.id == parent.id
                    )
                    function clickEvent(e: Event) {
                        //select the vat
                        vItemStore().selectItem(parent!.id)
                        e.stopPropagation()
                    }
                    shareButtons[i].removeEventListener("click", clickEvent)
                    shareButtons[i].addEventListener("click", clickEvent)
                    if (
                        vat?.shareStatus == "shared" ||
                        vat?.shareStatus == "pending"
                    ) {
                        //remove the share button
                        shareButtons[i].style.display = "none"
                    } else {
                        shareButtons[i].style.display = "block"
                    }
                }
            }
            for (let i = 0; i < shareText.length; i++) {
                //get closest parent element with id attribute
                const parent = shareText[i].closest("[id]")
                if (parent && parent.id) {
                    //Get the vat associated with the share button
                    const vat = this.getClaimedItems.find(
                        (e) => e.id == parent.id
                    )
                    if (vat?.shareStatus == "shared") {
                        shareText[i].style.display = "block"
                    } else {
                        shareText[i].style.display = "none"
                    }
                }
            }
        },
        getPrizeByID(id: string) {
            return prizeStore().getPrizeByID(id)
        },
        getPoolByID(id: string) {
            return dropPoolStore().getPoolByID(id)
        },
        getCategoryByID(id: string) {
            return categoryStore().getItemByID(id)
        },

        clickForPrize(item: VItem) {
            if (item.type == "loyalty") {
                navigationStore().emitAction({
                    type: ActionType.OPEN_POPUP,
                    value: "loyalty",
                })
                setTimeout(() => {
                    this.configureLoyalty()
                }, 10)
            } else {
                vItemStore().selectItem(item.id!)
                const campaignId = authStore().getCampaignID

                // Navigate to prize page with gameplay facecard
                this.$router.push(`/${campaignId}/prize/${item.id}?type=gameplay`)
            }
        },
        async clickForRedemption(item: VItem) {
            if (item?.shareStatus == "pending") {
                navigationStore().emitAction({
                    type: ActionType.OPEN_POPUP,
                    value: "reshare-cancel-share-reward",
                })
                return
            }

            vItemStore().selectItem(item.id!)
            const campaignId = authStore().getCampaignID

            // Navigate to prize page with redemption facecard
            this.$router.push(`/${campaignId}/prize/${item.id}?type=redemption`)
        },



        showRedeemedPopup(item: VItem) {
            vItemStore().selectItem(item.id!)
            const prize = this.getPrizeByID(item.prizeId!)
            if (prize && prize.redemptionType === RedemptionType.SCAN) {
                navigationStore().emitAction({
                    type: ActionType.OPEN_POPUP,
                    value: "already-redeemed-qr",
                })
            } else if (prize && prize.redemptionType === RedemptionType.MOMINT_NFT) {
                navigationStore().emitAction({
                    type: ActionType.OPEN_POPUP,
                    value: "already-redeemed-momint-nft",
                })
            } else if (prize && prize.redemptionType === RedemptionType.TAP_REDEEM) {
                navigationStore().emitAction({
                    type: ActionType.OPEN_POPUP,
                    value: "already-redeemed-tap-to-redeem",
                })
            } else if (prize && prize.redemptionType === RedemptionType.VOUCHER) {
                navigationStore().emitAction({
                    type: ActionType.OPEN_POPUP,
                    value: "already-redeemed-voucher",
                })
            } else if (prize && prize.redemptionType === RedemptionType.LINK_VOUCHER) {
                navigationStore().emitAction({
                    type: ActionType.OPEN_POPUP,
                    value: "already-redeemed-url-voucher",
                })
            } else if (prize && prize.redemptionType === RedemptionType.YOYO_COUPON) {
                navigationStore().emitAction({
                    type: ActionType.OPEN_POPUP,
                    value: "already-redeemed-yoyo-coupon",
                })
            }
        },


        getCategoryContainer(categoryId: string, type: string): Container {
            const emptyContainer = emptyContainerWithMessage(
                "Error",
                "Category missing"
            )
            const category = this.getCategoryByID(categoryId)
            if (category) {
                switch (type) {
                    case "claimed":
                        return category.unAllocatedComponent
                            ? category.unAllocatedComponent
                            : emptyContainer
                }
            }
            return emptyContainer
        },
        getPrizeContainer(prizeId: string, type: string): Container {
            const emptyContainer = emptyContainerWithMessage(
                "Error",
                "Prize missing"
            )
            const prize = this.getPrizeByID(prizeId)
            if (prize) {
                switch (type) {
                    case "redeem":
                        return prize.redeemedComponent
                            ? prize.redeemedComponent
                            : emptyContainer
                    case "allocated":
                        return prize.allocatedComponent
                            ? prize.allocatedComponent
                            : emptyContainer
                    default:
                        return emptyContainer
                }
            }
            return emptyContainer
        },
    },
})
</script>

<style scoped lang="scss">
.scroller {
    position: relative;
    padding: 10px 0;
}

.item-cell {
    display: inline-block;
    width: 50%;
    overflow: hidden;

    .item-center {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        padding: 10px;
    }
}

.grey-out {
    opacity: 0.7;
}
</style>
